import { createAction, props } from '@ngrx/store';
import {
  DirectPaymentConfig,
  PaymentMethod,
  PaymentProvider,
} from '@pay/pricing-multitenant-direct-payment/data/direct-payment-config.data';
import { DirectPaymentConfigsUiState } from './direct-payment-configs.state';

export const setDirectPaymentConfigs = createAction(
  '[DirectPaymentConfigs] SET_CONFIGS',
  props<{ configs: DirectPaymentConfig[] }>()
);
export const setDirectPaymentConfigsLoading = createAction(
  '[DirectPaymentConfigs] SET_LOADING',
  props<{ loading: boolean }>()
);
export const updateDirectPaymentUI = createAction(
  '[DirectPaymentConfigs] UPDATE_UI',
  props<{ ui: Partial<DirectPaymentConfigsUiState> }>()
);
export const setEditingDirectPaymentConfig = createAction(
  '[DirectPaymentConfigs] SET_EDITING_CONFIG',
  props<{ config: DirectPaymentConfig | null }>()
);
export const setDirectPaymentTaxValue = createAction(
  '[DirectPaymentConfigs] SET_TAX_VALUE',
  props<{ taxValue: number | null }>()
);
export const setDirectPaymentCurrency = createAction(
  '[DirectPaymentConfigs] SET_CURRENCY',
  props<{ currency: string | null }>()
);
export const setAvailablePaymentMethods = createAction(
  '[DirectPaymentConfigs] SET_AVAILABLE_PAYMENT_METHODS',
  props<{ methods: PaymentMethod[]; isLoading: boolean }>()
);
export const setAllowedPaymentProviders = createAction(
  '[DirectPaymentConfigs] SET_ALLOWED_PAYMENT_PROVIDERS',
  props<{ providers: PaymentProvider[]; isLoading: boolean }>()
);
export const resetDirectPaymentConfigs = createAction('[DirectPaymentConfigs] RESET');
